import type { Category } from '@/mocks/shows';

interface CategoryTabsProps {
  categories: Category[];
  activeSlug: string;
  onCategoryChange: (slug: string) => void;
}

export default function CategoryTabs({ categories, activeSlug, onCategoryChange }: CategoryTabsProps) {
  return (
    <div className="flex items-center gap-3 flex-wrap">
      {categories.map((cat) => {
        const isActive = activeSlug === cat.slug;
        return (
          <button
            key={cat.slug}
            onClick={() => onCategoryChange(cat.slug)}
            className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
              isActive
                ? 'bg-primary-500 text-background-50'
                : 'bg-background-100 text-foreground-700 hover:bg-secondary-100 hover:text-secondary-800'
            }`}
          >
            <span className={`w-4 h-4 flex items-center justify-center`}>
              <i className={`${cat.icon} text-sm`}></i>
            </span>
            <span>{cat.name}</span>
            {!isActive && (
              <span className="text-xs opacity-60">({cat.count})</span>
            )}
          </button>
        );
      })}
    </div>
  );
}